(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-assistant"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__ssAssistant) return;
    window.__ssAssistant = true;

    var STOP = ('a an and are as at be but by do does for from how i if in is it its my of on or '
      + 'our so that the their there they this to was we what when where which who will with you your'
      ).split(' ');

    function norm(s) {
      return (s || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
    }
    function tokens(s) {
      return norm(s).split(' ').filter(function (t) { return t.length > 2 && STOP.indexOf(t) === -1; });
    }

    function init(root) {
      var dataEl = root.querySelector('[data-ss-asst-data]');
      if (!dataEl) return;
      var cfg;
      try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!cfg.items || !cfg.items.length) return;

      // Pre-tokenise once. Keywords are weighted higher than the question text
      // because they are the words the owner knows people actually type.
      cfg.items.forEach(function (it) {
        it._q = tokens(it.q);
        it._k = tokens(it.k);
      });

      var panel = root.querySelector('[data-ss-asst-panel]') || root.querySelector('#ss-asst-panel');
      var log   = root.querySelector('[data-ss-asst-log]');
      var chips = root.querySelector('[data-ss-asst-chips]');
      var form  = root.querySelector('[data-ss-asst-form]');
      var input = root.querySelector('[data-ss-asst-input]');
      var openB = root.querySelector('[data-ss-asst-open]');
      var closeB= root.querySelector('[data-ss-asst-close]');
      var started = false;

      function say(text, who) {
        var p = document.createElement('div');
        p.className = 'ss-asst__msg ss-asst__msg--' + (who || 'bot');
        p.innerHTML = text;
        log.appendChild(p);
        log.scrollTop = log.scrollHeight;
      }

      function showChips(list) {
        chips.innerHTML = '';
        list.forEach(function (it) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ss-asst__chip';
          b.textContent = it.q;
          b.addEventListener('click', function () { ask(it.q, it); });
          chips.appendChild(b);
        });
      }

      function suggestions(exclude) {
        return cfg.items.filter(function (i) { return i !== exclude; })
                        .sort(function () { return 0.5 - Math.random(); })
                        .slice(0, 3);
      }

      function match(q) {
        var t = tokens(q);
        if (!t.length) return null;
        var best = null, bestScore = 0, bestHits = 0;
        cfg.items.forEach(function (it) {
          var score = 0, hits = 0;
          t.forEach(function (tok) {
            if (it._k.indexOf(tok) !== -1) { score += 3; hits++; }
            else if (it._q.indexOf(tok) !== -1) { score += 2; hits++; }
            else if (norm(it.a).indexOf(tok) !== -1) { score += 0.5; }
          });
          // On a tie, prefer the entry that matched more distinct words.
          // "do you bring balloons" ties otherwise and the earlier entry wins.
          if (score > bestScore || (score === bestScore && hits > bestHits)) {
            bestScore = score; bestHits = hits; best = it;
          }
        });
        // Needs more than a single incidental word in the answer body, or
        // "party" alone would match everything.
        return bestScore >= 2 ? best : null;
      }

      // "hi, can I book the 14th for 12 kids" is the message the owner expects
      // most, and it is an intent rather than an FAQ lookup. Detect it first,
      // echo back what was understood, and send them to the form.
      // Split deliberately. "how much deposit" is a question with a real answer
      // on the FAQ, so a phrase like "how much" must not hijack it. Only an
      // explicit booking verb or a date jumps straight to the form.
      var BOOK_STRONG = /\b(book|booking|reserve|hold a date|avail|availabilit|enquir|inquir)\b/i;
      var BOOK_WEAK   = /\b(quote|how much|price|pricing|cost|interested)\b/i;
      var DATEY = /\b(\d{1,2}\s*(st|nd|rd|th)|\d{1,2}\/\d{1,2}|jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec|monday|tuesday|wednesday|thursday|friday|saturday|sunday|weekend|next month)\b/i;

      function guestCount(t) {
        var m = t.match(/(\d{1,3})\s*(kids|kid|children|child|guests|guest|people|pax)\b/i);
        if (m) return parseInt(m[1], 10);
        // "book for 12" with no noun
        var m2 = t.match(/\bfor\s+(\d{1,3})\b/i);
        return m2 ? parseInt(m2[1], 10) : null;
      }

      function bookingReply(text) {
        var parts = [cfg.booking];
        var n = guestCount(text);
        if (n !== null) {
          if (n < 10) {
            parts.push('You mentioned ' + n + '. Our smallest package, Soir&eacute;e Royale, starts at 10 children, so do mention that in the form and we will see what we can do.');
          } else if (n < 15) {
            parts.push('With ' + n + ' children, Soir&eacute;e Royale is the one that fits. Classic Soir&eacute;e and Grande Soir&eacute;e each start at 15.');
          } else {
            parts.push('With ' + n + ' children, every package is open to you.');
          }
        } else {
          parts.push(cfg.minNote);
        }
        if (DATEY.test(text)) {
          parts.push('We cannot confirm a date here, so pop it in the form and we will check the calendar and come straight back to you.');
        }
        return parts.join(' ');
      }

      function ask(text, forced) {
        say(text.replace(/</g, '&lt;'), 'me');
        var hit = forced || match(text);
        // Order matters: strong booking signal first, then a real FAQ answer,
        // then a weak signal like "price" that the FAQ does not cover.
        var booking = !forced && (
          BOOK_STRONG.test(text) || DATEY.test(text) || (!hit && BOOK_WEAK.test(text))
        );
        if (booking) hit = null;
        setTimeout(function () {
          if (booking) {
            say(bookingReply(text)
              + ' Head straight to <a href="' + cfg.bookUrl + '">' + cfg.bookLabel + '</a>.');
          } else if (hit) {
            say(hit.a.replace(/</g, '&lt;'));
          } else {
            say(cfg.noMatch.replace(/</g, '&lt;')
              + ' <a href="' + cfg.bookUrl + '">' + cfg.bookLabel + '</a>.');
          }
          showChips(suggestions(hit));
        }, 260);
      }

      function start() {
        if (started) return;
        started = true;
        say(cfg.greeting.replace(/</g, '&lt;'));
        showChips(cfg.items.slice(0, 4));
      }

      function setOpen(open) {
        panel.hidden = !open;
        if (open) root.classList.add('is-settled');
        root.classList.toggle('is-open', open);
        openB.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { start(); setTimeout(function () { input.focus(); }, 60); }
        else { openB.focus(); }
      }

      openB.addEventListener('click', function () { setOpen(true); });
      closeB.addEventListener('click', function () { setOpen(false); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) setOpen(false);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = input.value.trim();
        if (!v) return;
        input.value = '';
        ask(v);
      });
    }

    function boot() {
      document.querySelectorAll('[data-ss-assistant]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-cart"] && !Shopify.designMode) return;
  try {
    
  // Progressive enhancement only. Every control is a real submit button, so
  // with this script absent the cart still works via a normal form post.
  (function () {
    if (window.__ssCartBound) return;
    window.__ssCartBound = true;

    function root() { return document.querySelector('[data-ss-cart]'); }

    function setCount(n) {
      document.querySelectorAll('.ss-hdr__bag-count').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    }

    async function refresh() {
      var el = root();
      if (!el) return;
      var res = await fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId()), {
        headers: { 'Accept': 'text/html' }
      });
      if (!res.ok) { window.location.reload(); return; }
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-ss-cart]');
      if (!next) { window.location.reload(); return; }
      el.replaceWith(next);
      next.querySelectorAll('[data-ss-reveal]').forEach(function (n) { n.classList.add('is-revealed'); });
    }

    var _sid = null;
    function sectionId() { return _sid; }

    async function change(line, quantity) {
      var el = root();
      if (el) el.setAttribute('data-ss-busy', '');
      try {
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });
        if (!res.ok) throw new Error('cart change failed');
        var cart = await res.json();
        setCount(cart.item_count);
        await refresh();
      } catch (e) {
        window.location.reload();
      }
    }

    document.addEventListener('click', function (e) {
      var el = root();
      if (!el || !_sid) return;
      var btn = e.target.closest('[data-ss-qty], [data-ss-remove]');
      if (!btn || !el.contains(btn)) return;
      var li = btn.closest('[data-ss-line]');
      if (!li) return;
      e.preventDefault();
      change(parseInt(li.getAttribute('data-ss-line'), 10), parseInt(btn.value, 10));
    });

    document.addEventListener('change', function (e) {
      var el = root();
      if (!el || !_sid) return;
      var input = e.target.closest('[data-ss-qty-input]');
      if (!input || !el.contains(input)) return;
      var li = input.closest('[data-ss-line]');
      if (!li) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) return;
      change(parseInt(li.getAttribute('data-ss-line'), 10), q);
    });

    document.addEventListener('DOMContentLoaded', function () {
      var el = root();
      if (el) _sid = el.getAttribute('data-ss-section-id');
    });
    var el0 = root();
    if (el0) _sid = el0.getAttribute('data-ss-section-id');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__ssPromoBound) return;
    window.__ssPromoBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ss-copy]');
      if (!btn) return;
      var code = btn.getAttribute('data-ss-copy');
      // Clipboard API needs a secure context; fall back to selecting the text
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        document.body.removeChild(ta);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
